<!--
@Author: Calvin Green <calvin>
@Date:   2021-05-12T21:25:16+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2021-08-25T10:21:08+02:00
@Copyright: Diversitude 2021
-->



<script>
import Layout from "../layouts/main-stripped";
import appConfig from "@/app.config";
import ColumnLayout from '../layouts/main-columns.vue'

export default {
  page: {
    title: "TestZone",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    ColumnLayout,
  },
  data() {
    return {

    };
  },
    computed: {
        
    },
    methods: {
        
    },
    mounted() {},
}
</script>
<template>
    <Layout>
      <ColumnLayout>
        <template #sidebar>
          Sidebar content
        </template>
        <template #main>
        </template>
      </ColumnLayout>
    </Layout>
</template>
<style>
.metismenu {
  padding-left: 0;
}
.metismenu, .metismenu ul {
  list-style: none;
}
.metismenu li {
  position: relative;
}
.metismenu li a {
  display: block;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #333;
  text-decoration: none;
  outline: 0 none;
}
.metismenu ul:before {
  position: absolute;
  border-left: 1px dotted #333;
  content: "";
  width: 30px;
  top: 25px;
  left: 5px;
  bottom: 17px;
}
.metismenu ul > li:before {
  position: absolute;
  border-top: 1px dotted #333;
  content: "";
  width: 30px;
  top: 13px;
  left: -26px;
}
li.active > a > span.fa-folder-o:before {
  content: "\f115" !important;
}

.activeBtn{
  font-weight: bold;
  text-decoration: underline;
}

#routerLinks.btn{
  color:forestgreen;
}
.routerBtn{
  color: #000 !important;
  background-color: unset !important;
  border-color: #eff2f7 !important;
}
.routerBtn.router-link-active{
  color: #000 !important;
  background-color: #eff2f7 !important;
  border-color: #eff2f7 !important;
}
</style>